import TYPES from './types';
import { put, post } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';

export const updateLaytimeEvents = params => dispatch => {
  const { id, table, ...rest } = params;

  dispatch({ type: TYPES.UPDATE_LAYTIME_EVENTS.START, payload: params });

  return put(`/enums/laytime-events/${id}`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_LAYTIME_EVENTS.SUCCESS, payload: response.data });
      dispatch(updateTableRow({ data: response.data.data, table }));
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.UPDATE_LAYTIME_EVENTS.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};

export const createLaytimeEvents = params => dispatch => {
  const { table, ...rest } = params;

  dispatch({ type: TYPES.CREATE_LAYTIME_EVENTS.START, payload: params });

  return post(`/enums/laytime-events`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.CREATE_LAYTIME_EVENTS.SUCCESS, payload: response.data });
      dispatch(successHandler({ title: 'Success!', message: 'Created successfully' }));
      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.CREATE_LAYTIME_EVENTS.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};
